export const GlobalFunctionName = Object.freeze({
  ON_BAEMIN_WEB_VIEW_WILL_APPEAR: 'baeminWebViewWillAppear',

  ON_INJECT_TYPED_DATA: 'injectCallback',
  ON_CLICK_NATIVE_BACK: 'onClickNativeBack'
})

// TODO check plugins/nativeBridge.js:7
export const setGlobalFunction = (name, callback) => {
  if (!Object.values(GlobalFunctionName).includes(name)) return
  if (typeof callback !== 'function') return

  window[name] = callback
}
